jQuery.cookie = function(name, value, options) {
    if (typeof value != 'undefined') { // name and value given, set cookie
    options = options || {};
    if (value === null) {
    value = '';
    options.expires = -1;
    }
    var expires = '';
    if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
    var date;
    if (typeof options.expires == 'number') {
    date = new Date();
    date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
    } else {
    date = options.expires;
    }
    expires = '; expires=' + date.toUTCString();
    }
    var path = options.path ? '; path=' + (options.path) : '';
    var domain = options.domain ? '; domain=' + (options.domain) : '';
    var secure = options.secure ? '; secure' : '';
    document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
    } else {
    var cookieValue = null;
    if (document.cookie && document.cookie != '') {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
    var cookie = jQuery.trim(cookies[i]);
    if (cookie.substring(0, name.length + 1) == (name + '=')) {
    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
    break;
    }
    }
    }
    return cookieValue;
    }
    };

    $(function(){

		var days = $('#NewsletterPopup-newsletter-popup').attr('data-days');

		var times = $('#NewsletterPopup-newsletter-popup').attr('data-times');

		var cookieVal = $.cookie('endTimes');

		console.log(cookieVal);

		if(cookieVal=='0'){

		}else{

			setTimeout(function(){

				$('#NewsletterPopup-newsletter-popup').fadeIn();

			},times);

			$.cookie('endTimes', '0', { expires: days });

		}

		$('.modal__close,.js-modal-close').click(function(){

			$('#NewsletterPopup-newsletter-popup').fadeOut();

		})

	})